/**
 * @generated SignedSource<<039371d467fb0ab33ece99f023ffb133>>
 * @relayHash 7d01262d5025697f028307c1ed6a3870
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6882ce66b70a24b78202abfbb7cd6c9229b8f3b47d2ae586672a184e84b32399

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type InvokeExtensionInput = {
  contextIds: ReadonlyArray<string>;
  entryPoint?: string | null | undefined;
  extensionDetails?: ExtensionDetailsInput | null | undefined;
  extensionId?: string | null | undefined;
  payload: AGG$JSON;
  schema?: string | null | undefined;
};
export type ExtensionDetailsInput = {
  definitionId: string;
  extensionKey: string;
};
export type dynamicPropertiesMutation$variables = {
  input: InvokeExtensionInput;
};
export type dynamicPropertiesMutation$data = {
  readonly invokeExtension: {
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly statusCode: number | null | undefined;
      } | null | undefined;
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly response: {
      readonly body: AGG$JSON;
    } | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type dynamicPropertiesMutation = {
  response: dynamicPropertiesMutation$data;
  variables: dynamicPropertiesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "concreteType": "InvocationResponsePayload",
  "kind": "LinkedField",
  "name": "response",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "body"
    }
  ]
},
v4 = {
  "kind": "ScalarField",
  "name": "message"
},
v5 = {
  "kind": "ScalarField",
  "name": "statusCode"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "dynamicPropertiesMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "InvokeExtensionResponse",
        "kind": "LinkedField",
        "name": "invokeExtension",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v5/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "dynamicPropertiesMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "InvokeExtensionResponse",
        "kind": "LinkedField",
        "name": "invokeExtension",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v5/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "6882ce66b70a24b78202abfbb7cd6c9229b8f3b47d2ae586672a184e84b32399",
    "metadata": {},
    "name": "dynamicPropertiesMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "d8ddf6e5c2dae3430b192a70c44d0079";

export default node;
